import { useStudyTimeTracker } from '@/hooks/useStudyTimeTracker';
import { usersAPI } from '@/services/api/users.api';

/**
 * Cronómetro de sesión en las páginas de vocabulario (Progreso). Acumula tiempo
 * de estudio en el día local del servidor mediante deltas (vía
 * `useStudyTimeTracker`). Solo contabiliza tiempo — NO marca racha.
 *
 * @param enabled  activa/desactiva el cronómetro
 * @returns  `studySeconds` — segundos locales de la sesión
 */
export function useVocabularyStudyTimer(enabled: boolean): { studySeconds: number } {
  const { time } = useStudyTimeTracker(enabled, usersAPI.addVocabularyStudyDelta);
  return { studySeconds: time };
}
